import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AssetTransferService = {
    list: async (data) => axios.post(API_URL + "/assetTransfer/list", data).then(({data}) => data).catch((err) => { throw err }),
    create: async (data) => axios.post(API_URL + `/assetTransfer`, data).then(({data}) => data).catch((err) => { throw err }),
}

export default AssetTransferService;
